import ButtonGroup1, { ButtonGroup1Props } from './ButtonGroup1';

export type { ButtonGroup1Props };
export default ButtonGroup1;
